<div class="opp-risks-heading-section">
    <!-- <span class="opp-risks-heading">Optimization Opportunities</span> -->
    <span class="opp-risks-heading">{{page_name}}</span>
    <!-- <div class="opp-risks-filter-section">
        <mat-select class="opp-riks-filter-input" [(ngModel)]="selected_opportunity_period" (selectionChange)="opportunityPeriodChanged(selected_opportunity_period)">
            <mat-option [value]="0">All</mat-option>
            <mat-option [value]="'0-6 months'">6 Months</mat-option>
            <mat-option [value]="'6-12 months'">12 Months</mat-option>
            <mat-option [value]="'12-18 months'">18 Months</mat-option>
            <mat-option [value]="'18+ months'">24 Months</mat-option>
        </mat-select>
    </div> -->
    <div class="opp-risks-filter-section">
        <mat-select class="opp-riks-filter-input" [(ngModel)]="selected_opportunity_period" (selectionChange)="getOpportunutiesData()">
            <mat-option [value]="'previous_year'"  *ngIf = 'user_details.role.role == 8 || user_details.role.role == 13'>Previous Year</mat-option>
            <mat-option [value]="'current_year'">Current Year</mat-option>
            <mat-option [value]="'next_year'">2 Years</mat-option>
            <mat-option [value]="'next_two_years'">3 Years</mat-option>
            <mat-option [value]="'next_three_years'">4 Years</mat-option>
        </mat-select>
    </div>
</div>
<ng-container *ngIf="opportunities_data_loaded">
    <div class="opp-risks-content-section" [ngClass]="{'content-end': ((!user_details.is_book_optimized) && ((user_role == 'Advisor') || (user_role == 'AFA')))}">
        <div class="each-opp-risk-section" *ngFor="let data of opp_risks_data; let index = index;" [ngClass]="{'each-opp-risk-section-afa': (user_role == 'Advisor Manager' || user_role == 'AFA')}">
            <div class="each-opp-risk-count-section">
                <p class="each-opp-risk-count" *ngIf="data.format_number">{{ commonService.abbreviateNumber(getKey(opportunities_data, data.key)) }}</p>
                <p class="each-opp-risk-count" *ngIf="!data.format_number">{{getKey(opportunities_data, data.key) }}</p>
                <img [src]="data.image" class="each-opp-risk-image" />
            </div>
            <div class="each-opp-risk-name">
                <span>{{ data.name }}</span>
                <div class="section-heading-tooltip-block" *ngIf="data.tooltip">
                    <img src="assets/info-black.png" />
                    <div class="section-heading-tooltip-section"style="width: 500px;" [ngClass]="{'last-option': (index > opp_risks_data.length - 2)}">
                        <div class="module-page-information-section" *ngFor="let section of data.tooltipText">
                            <div class="each-module-page-information-section">
                            <p class="each-module-page-information-heading">{{section.name}}</p>
                            </div>
                            <ng-container *ngIf="section.sub_sections">
                                <ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
                                    <div class="each-module-page-information-sub-section">
                                        <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
                                        <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
                                        <ng-container *ngIf="sub_section.sub_sections">
                                            <div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
                                            <p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
                                            <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <span class="each-opp-risk-sub-name">{{ data.sub_name }}({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
            <span class="each-opp-risk-sub-count" *ngIf="data.format_number"> : {{ commonService.abbreviateNumber(getKey(opportunities_data, data.sub_key)) }}</span>
            <span class="each-opp-risk-sub-count" *ngIf="!data.format_number"> : {{ getKey(opportunities_data, data.sub_key) }}</span>
            <div class="each-opp-risk-action">
                <div>
                    <ng-container *ngIf="data.show_analysis">
                        <button class="analysis-button" (click)="changePageState(data, 'analysis')">View Analysis</button>
                    </ng-container>
                </div>
                <div [ngStyle]="{ cursor: data.clickable == true ? 'pointer' : 'default' }" (click)="changePageState(data, '')">
                    <img src="assets/portfolio-nav-arrow.png" class="each-opp-risk-action-image" *ngIf="data.clickable" />
                    <img src="assets/portfolio-nav-arrow-hover.png" class="each-opp-risk-action-hover-image" *ngIf="data.clickable" />
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!opportunities_data_loaded">
    <app-loader [loading_text]="'Loading'"></app-loader>
</ng-container>

<!-- <div class="differentiated-analysis-heading-section">
    <span class="differentiated-analysis-heading">Differentiated Analysis</span>
</div>
<div class="differentiated-analysis-content-section">
    <div class="differentiated-analysis-graph-section">
        <div class="differentiated-analysis-graph">
            <div id="upside-opportunity-graph"></div>
        </div>
        <div class="differentiated-analysis-graph-content">
            <ng-container *ngIf="upside_opportunuty_name == ''">
            <div class="differentiated-analysis-graph-heading-section">
                <span>Upside Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
                <span class="each-differentiated-analysis-graph-value">{{opportunities_data.upside_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
                <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.upside_opp_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Predicted Opp Value</span>
                <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.upside_opp_value)}}</span>
            </div>
            </ng-container>
            <ng-container *ngIf="upside_opportunuty_name == 'Rule Based Triggers'">
            <div class="differentiated-analysis-graph-heading-section">
                <span>Rule Based Triggers Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
                <span class="each-differentiated-analysis-graph-value">{{opportunities_data.upside_rulebased_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
                <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.upside_rulebased_opp_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Predicted Opp Value</span>
                <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.upside_rulebased_opp_value)}}</span>
            </div>
            </ng-container>
            <ng-container *ngIf="upside_opportunuty_name == 'AI Triggers'">
            <div class="differentiated-analysis-graph-heading-section">
                <span>AI Triggers Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
                <span class="each-differentiated-analysis-graph-value">{{opportunities_data.upside_ai_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
                <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.upside_ai_opp_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Predicted Opp Value</span>
                <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.upside_ai_opp_value)}}</span>
            </div>
            </ng-container>
            <ng-container *ngIf="upside_opportunuty_name == 'Manual'">
            <div class="differentiated-analysis-graph-heading-section">
                <span>Manual Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
                <span class="each-differentiated-analysis-graph-value">{{opportunities_data.upside_manual_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
                <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.upside_manual_opp_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
                <span class="each-differentiated-analysis-graph-label">Predicted Opp Value</span>
                <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.upside_manual_opp_value)}}</span>
            </div>
            </ng-container>
        </div>
    </div>
    <div class="differentiated-analysis-table-section">
        <div class="differentiated-analysis-graph-heading-section">
            <span>Upside Opportunities Analysis</span>
            <span class="triggers-link" (click)="openUpsideOpportunityTriggersModal('Opportunity')">View Triggers</span>
        </div>
        <table class="differentiated-analysis-table">
            <thead>
            <tr>
                <th></th>
                <th>Count</th>
                <th>Predicted Opportunity</th>
                <th>Focus</th>
                <th>Automation</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let opp of opportunities_data.upside_table">
                <td>{{opp.name}}</td>
                <td>{{commonService.abbreviateNumber(opp.count)}}</td>
                <td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opp.value)}}</td>
                <td>{{commonService.abbreviateNumber(opp.focus)}}</td>
                <td>{{opp.automation}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="differentiated-analysis-content-section">
    <div class="differentiated-analysis-graph-section">
        <div class="differentiated-analysis-graph">
        <div id="retention-opportunity-graph"></div>
        </div>
        <div class="differentiated-analysis-graph-content">
        <ng-container *ngIf="retention_opportunuty_name == ''">
            <div class="differentiated-analysis-graph-heading-section">
            <span>Retention Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
            <span class="each-differentiated-analysis-graph-value">{{opportunities_data.retention_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
            <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.retention_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Predicted Loss Value</span>
            <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.retention_value)}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="retention_opportunuty_name == 'Rule Based Triggers'">
            <div class="differentiated-analysis-graph-heading-section">
            <span>Rule Based Triggers Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
            <span class="each-differentiated-analysis-graph-value">{{opportunities_data.retention_rulebased_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
            <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.retention_rulebased_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Predicted Loss Value</span>
            <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.retention_rulebased_value)}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="retention_opportunuty_name == 'AI Triggers'">
            <div class="differentiated-analysis-graph-heading-section">
            <span>AI Triggers Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
            <span class="each-differentiated-analysis-graph-value">{{opportunities_data.retention_ai_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
            <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.retention_ai_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Predicted Loss Value</span>
            <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.retention_ai_value)}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="retention_opportunuty_name == 'Manual'">
            <div class="differentiated-analysis-graph-heading-section">
            <span>Manual Opportunities</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Percentage of Clients</span>
            <span class="each-differentiated-analysis-graph-value">{{opportunities_data.retention_manual_client_percentage}}%</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">No. of Opportunities</span>
            <span class="each-differentiated-analysis-graph-value">{{commonService.abbreviateNumber(opportunities_data.retention_manual_count)}}</span>
            </div>
            <div class="each-differentiated-analysis-graph-details">
            <span class="each-differentiated-analysis-graph-label">Predicted Loss Value</span>
            <span class="each-differentiated-analysis-graph-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(opportunities_data.retention_manual_value)}}</span>
            </div>
        </ng-container>
        </div>
    </div>
    <div class="differentiated-analysis-table-section">
        <div class="differentiated-analysis-graph-heading-section">
        <span>Retention Opportunities Analysis</span>
        <span class="triggers-link" (click)="openUpsideOpportunityTriggersModal('Retention')">View Triggers</span>
        </div>
        <table class="differentiated-analysis-table">
        <thead>
            <tr>
            <th></th>
            <th>Count</th>
            <th>Predicted Loss</th>
            <th>Focus</th>
            <th>Automation</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let risk of opportunities_data.retention_table">
            <td>{{risk.name}}</td>
            <td>{{commonService.abbreviateNumber(risk.count)}}</td>
            <td>{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(risk.value)}}</td>
            <td>{{commonService.abbreviateNumber(risk.focus)}}</td>
            <td>{{risk.automation}}</td>
            </tr>
        </tbody>
        </table>
    </div>
</div> -->


<ng-template #upsideOpportunityTriggersModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>View {{upside_opportunity_trigger_type}} Triggers</span>
            <span class="page-modal-close-icon" (click)="closeUpsideOpportunityTriggersModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <div class="page-modal-input-section">
                <mat-select class="page-modal-input" [(ngModel)]="upside_opportunity_trigger_filter" (selectionChange)="getUpsideOpportunityTriggersData()">
                    <mat-option [value]="'all'">All</mat-option>
                    <mat-option [value]="'age'">Age</mat-option>
                    <mat-option [value]="'date'">Date</mat-option>
                    <mat-option [value]="'data'">Data</mat-option>
                    <mat-option [value]="'ai'">AI</mat-option>
                </mat-select>
            </div>
            <div class="page-inner-section" *ngIf="upside_opportunity_trigger_data_loaded">
                <table class="page-inner-table">
                    <thead>
                        <tr>
                            <th *ngFor="let column of upside_opportunity_trigger_data.table_columns">{{ column }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of upside_opportunity_trigger_data.table_data | paginate : { id: 'upside-opportunity-trigger-data', itemsPerPage: 10, currentPage: upside_opportunity_trigger_current_page, totalItems: upside_opportunity_trigger_data.table_data.length }">
                            <td *ngFor="let column of upside_opportunity_trigger_data.table_columns">
                                <span>{{data[column]}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="upside_opportunity_trigger_data.table_columns.length" *ngIf="upside_opportunity_trigger_data.table_data.length == 0">
                                <div class="new-table-v2-zero-state">
                                    <span>No Triggers Found</span>
                                  </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ng-container *ngIf="!upside_opportunity_trigger_data_loaded">
                <app-loader [loading_text]="'Loading Triggers Data'"></app-loader>
            </ng-container>
        </div>
        <div class="page-modal-footer-section">
            <pagination-controls id="upside-opportunity-trigger-data" (pageChange)="upside_opportunity_trigger_current_page = $event" style="text-align: right; position: relative; top: 6px"></pagination-controls>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="closeUpsideOpportunityTriggersModal()">Cancel</button>
        </div>
    </div>
</ng-template>
